import React, { Component } from 'react';
import { Button, Modal, Form, Spin, Input } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";
import { FormItem } from 'utils/form_helpers';
import { Error } from "components/common";
import { CitySelect } from 'components/blocks/City';


class DistrictForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { actions, district } = this.props;
        const instance = district.editObject;

        let data = Object.assign({}, values);
        if (instance && instance.id) {
          data.id = instance.id;
        }
        actions.districtUpdate(data);
      }
    });
  };

  close = () => {
    const { actions } = this.props;
    actions.districtShowEditForm({ show: false });
  };

  render() {
    const { form, district, cityId } = this.props;
    const { showEditForm, updateStatus, editObject } = district;
    const instance = editObject;

    const error = updateStatus.error || {};
    const errorData = error.data || {};

    const isLoading = district.updateStatus.isLoading;

    return (
      <Modal
        visible={showEditForm}
        title="Редактирование района"
        onCancel={this.close}
        maskClosable={false}
        destroyOnClose={true}
        footer={[
          <Button key="cancel" onClick={this.close} disabled={isLoading}>Отмена</Button>,
          <Button key="submit" type="primary" loading={isLoading} onClick={this.handleSubmit}>
            Сохранить
          </Button>,
        ]}
      >
        <Spin spinning={isLoading}>
          <Form onSubmit={this.handleSubmit}>
            <Error errors={errorData.non_field_errors}/>

            <CitySelect
              form={form}
              instance={instance}
              name="city"
              label="Город"
              required={true}
              errorData={errorData}
              initialValue={cityId}
            />

            <FormItem
              form={form}
              instance={instance}
              name="name"
              label="Название"
              required={true}
              errorData={errorData}

            >
              <Input size="large"/>
            </FormItem>

            <FormItem
              form={form}
              instance={instance}
              name="slug"
              label="Путь"
              required={true}
              errorData={errorData}

            >
              <Input size="large"/>
            </FormItem>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

const WrappedDistrictForm = Form.create()(DistrictForm);

function mapStateToProps(state) {
  return {
    district: state.district,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.district), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrappedDistrictForm);

